
// import { component } from 'vue/types/umd';
export default [
    /*** 补充调剂信息审核（用户  需审核） ***/
    {
        path: '/adjust/supplement',
        component: () => import('../pages/adjust/supplement/index.vue'),
        meta: { title: '补充调剂信息审核' }
    },
    /*** 协助调剂 ***/
    {
        path: '/adjust/assist',
        component: () => import('../pages/adjust/assist/index.vue'),
        meta: { title: '协助调剂' }
    },
    /*** 补充调剂信息审核（员工 无需审核） ***/
    {
        path: '/adjust/employeesupplement',
        component: () => import('../pages/adjust/employeeSupplement/index.vue'),
        meta: { title: '补充调剂信息审核' }
    },
    /*** 补充调剂文章咨询 ***/
    {
        path: '/adjust/article',
        component: () => import('../pages/adjust/article/index.vue'),
        meta: { title: '补充调剂文章咨询' }
    },

    /*** 信息更新 ***/
    {
        path: '/adjust/information',
        component: () => import('../pages/adjust/information/index.vue'),
        meta: { title: '调剂信息更新' }
    },

    /*** 调剂推荐 ***/
    {
        path: '/adjust/recommend',
        component: () => import('../pages/adjust/recommend/index.vue'),
        meta: { title: '调剂推荐' }
    },


    {
        path: '/adjust/overview',
        component: () => import('../pages/adjust/overview.vue'),
        meta: { title: '调剂信息总览' }
    },
    {
        path: '/adjust/report',
        component: () => import('../pages/adjust/report/index.vue'),
        meta: { title: '调剂报告' }
    },
    {
        path: '/adjust/helpCenter',
        component: () => import('../pages/adjust/helpCenter/index.vue'),
        meta: { title: '帮助中心' }
  },
  {
       path: '/adjust/adjustApply',
       component: () => import('../pages/adjust/adjustapply/adjustapply.vue'),
       meta: { title: '信息审核' }
  },{
      path: '/adjust/institutionalUser',
      component: () => import('../pages/adjust/institutionalUser/index.vue')  ,
      meta:{title:'机构用户'}
  }
    
]